/**
 * Format: $track('test', {c: 'testcat', l: 'testlab', v: 'testval'}, ['ga']);
 */
const track = () => {
    return (action, data = {}, providers = []) => {
        if (providers.includes('ga')) {
            prov_ga.track(action, data);
        }
    }
};

//google analytics
const prov_ga = {
    track: (action, data) => {
        if (typeof gtag === 'undefined') {
            return;
        }

        let {c: category, l: label, v: value} = data;

        const eventData = {};

        if (category !== undefined) {
            eventData.event_category = category;
        }

        if (label !== undefined) {
            eventData.event_label = label;
        }

        if (value !== undefined) {
            eventData.value = value;
        }

        gtag('event', action, eventData);
    }
};

export default track;